import {Record as ImmRecord, type RecordOf} from 'immutable';

// Contains the shared data between all plugins

// This context is not related to React context or Designer "Dynamo context".
// This is all data from the page / site that could be required at some point
// by any plugin / atom to render a page.
// This shared context should be kept to a minimum, as almost all contextual
// data will be required exclusively by only one plugin, so it can probably be
// passed between atoms of that same plugin as part of the `pluginsContext`,
// instead of adding it to `sharedContext`.

export type SharedContextProps = {
  hrefMap: {
    [key: string]: string;
  };
  pageHref: string | null | undefined;
};

const defaultSharedContextProps: SharedContextProps = {
  hrefMap: {},
  pageHref: null,
};

/**
 * @deprecated No new fields should be added to this record. If you need to add
 * data that is globally available add it to `@packages/systems/render` RenderContext.
 */
export const SharedContext: ImmRecord.Factory<SharedContextProps> = ImmRecord(
  defaultSharedContextProps,
  'SharedContext'
);

export type SharedContextType = RecordOf<SharedContextProps>;
